import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import ConfirmEmailPage from './pages/ConfirmEmailPage'; // 🔥 NUOVO: Pagina conferma email
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import DashboardPage from './pages/DashboardPage';
import ScrapingPage from './pages/ScrapingPage';
import SchedulerPage from './pages/SchedulerPage';
import StoricoGarePage from './pages/StoricoGarePage';
import AvvisoDetailPage from './pages/AvvisoDetailPage'; // 🔥 NUOVO: Pagina dettagli avviso
import UserManagementPage from './pages/UserManagementPage'; // 🔥 NUOVO
import NotifichePage from './pages/NotifichePage'; // 🔥 NUOVO: Pagina Notifiche
import SettingsPage from './pages/SettingsPage'; // 🔥 NUOVO: Impostazioni Admin
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import CookiePolicyPage from './pages/CookiePolicyPage';
import { useAuth } from './hooks/useAuth';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout'; // 🔥 NUOVO: Layout con Header e Footer
import CookieBanner from './components/CookieBanner';

function App() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Caricamento...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <Routes>
        {/* Route pubbliche */}
        <Route 
          path="/login" 
          element={isAuthenticated ? <Navigate to="/dashboard" /> : <LoginPage />} 
        />

        {/* Documenti legali (pubblici) */}
        <Route path="/termini" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/cookie-policy" element={<CookiePolicyPage />} />
        
        {/* 🔒 Conferma Email - Route pubblica */}
        <Route 
          path="/confirm-email" 
          element={<ConfirmEmailPage />} 
        />

        {/* 🔒 Password dimenticata - Route pubbliche */}
        <Route
          path="/forgot-password"
          element={isAuthenticated ? <Navigate to="/dashboard" /> : <ForgotPasswordPage />}
        />
        <Route
          path="/reset-password"
          element={isAuthenticated ? <Navigate to="/dashboard" /> : <ResetPasswordPage />}
        />
        
        {/* Dashboard - CON Layout */}
        <Route 
          path="/dashboard" 
          element={
            isAuthenticated ? (
              <Layout>
                <DashboardPage />
              </Layout>
            ) : (
              <Navigate to="/login" />
            )
          } 
        />
        
        {/* 🔥 SCRAPING - Solo Admin - CON Layout */}
        <Route 
          path="/scraping" 
          element={
            <ProtectedRoute requiredPermission="view_scraping">
              <Layout>
                <ScrapingPage />
              </Layout>
            </ProtectedRoute>
          } 
        />
        
        {/* 🔥 SCHEDULER - Admin + Associati - CON Layout */}
        <Route 
          path="/scheduler" 
          element={
            <ProtectedRoute requiredPermission="view_scheduler">
              <Layout>
                <SchedulerPage />
              </Layout>
            </ProtectedRoute>
          } 
        />
        
        {/* 🔥 STORICO GARE - Tutti - CON Layout */}
        <Route 
          path="/storico-gare" 
          element={
            <ProtectedRoute requiredPermission="view_storico">
              <Layout>
                <StoricoGarePage />
              </Layout>
            </ProtectedRoute>
          } 
        />
        
        {/* 🔥 DETTAGLI AVVISO - Tutti - CON Layout */}
        <Route 
          path="/storico-gare/:avviso_id" 
          element={
            <ProtectedRoute requiredPermission="view_storico">
              <Layout>
                <AvvisoDetailPage />
              </Layout>
            </ProtectedRoute>
          } 
        />
        
        {/* 🔥 GESTIONE RUOLI - Solo Admin - CON Layout */}
        <Route 
          path="/user-management" 
          element={
            <ProtectedRoute requiredPermission="manage_users">
              <Layout>
                <UserManagementPage />
              </Layout>
            </ProtectedRoute>
          } 
        />
        
        {/* 🔥 NOTIFICHE - Solo Associati e Admin - CON Layout */}
        <Route 
          path="/notifiche" 
          element={
            <ProtectedRoute requiredAnyPermission={["view_scheduler", "manage_users"]}>
              <Layout>
                <NotifichePage />
              </Layout>
            </ProtectedRoute>
          } 
        />

        {/* 🔥 IMPOSTAZIONI (ADMIN) - CON Layout */}
        <Route
          path="/settings"
          element={
            <ProtectedRoute requiredRole="admin">
              <Layout>
                <SettingsPage />
              </Layout>
            </ProtectedRoute>
          }
        />
        
        {/* Redirect root */}
        <Route 
          path="/" 
          element={<Navigate to={isAuthenticated ? "/dashboard" : "/login"} />} 
        />
      </Routes>
      <CookieBanner />
    </div>
  );
}

export default App;
